import React from 'react';
import { ArrowRight, ArrowDown, Sparkles } from 'lucide-react';
import { Button } from '../components/ui/button';

const HeroImageTest = () => {
  // Sample abstract/ethereal images similar to Límites style
  const testImages = [
    {
      name: "Esfera dorada etérea",
      url: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&q=80",
      fallback: true
    },
    {
      name: "Luz dorada abstracta", 
      url: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80",
      fallback: true
    },
    {
      name: "Geometría sagrada",
      url: "https://images.unsplash.com/photo-1618005198919-d3d4b5a92ead?w=800&q=80",
      fallback: true
    }
  ];

  return (
    <div className="pt-20 bg-gray-100 min-h-screen">
      {/* Header */}
      <div className="bg-gray-900 text-white py-6 px-6 text-center">
        <h1 className="text-2xl font-bold">Hero con imagen estilo Límites</h1>
        <p className="text-gray-300 mt-2">Imagen decorativa sutil + texto centrado</p>
      </div>

      {/* OPCIÓN 1: Círculo/esfera con imagen abstracta arriba */}
      <div className="py-12 px-4 bg-[#faf8f5]">
        <h2 className="text-xl font-bold text-center mb-8 text-[#c9a227]">
          OPCIÓN 1: Esfera dorada arriba del texto (como elemento decorativo)
        </h2>
        
        <div className="max-w-5xl mx-auto">
          <section className="min-h-[550px] flex flex-col items-center justify-center py-16 text-center">
            {/* Decorative sphere/circle above */}
            <div className="mb-10 relative">
              <div className="w-32 h-32 rounded-full bg-gradient-to-br from-[#e8d5a3] via-[#c9a227] to-[#b8922a] opacity-80 blur-sm absolute inset-0" />
              <div className="w-32 h-32 rounded-full bg-gradient-to-br from-[#e8d5a3]/60 via-[#c9a227]/40 to-transparent relative" />
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-16 h-16 rounded-full bg-white/40 blur-md" />
            </div>
            
            {/* Badge */}
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#c9a227]/10 text-[#c9a227] rounded-full text-sm font-medium mb-8">
              <Sparkles className="w-4 h-4" />
              Escuela de Consciencia Akáshica
            </div>
            
            {/* Title */}
            <h1 className="text-5xl lg:text-7xl font-serif text-gray-800 tracking-tight mb-6 leading-[1.1]">
              Un espacio para
              <span className="block text-[#c9a227]">volver a ti</span>
            </h1>
            
            {/* Subtitle */}
            <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-10 leading-relaxed font-light">
              Sin prisa. Sin ruido. De la desconexión a habitar tu vida con claridad.
            </p>
            
            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button className="bg-[#c9a227] hover:bg-[#b89220] text-white px-8 py-6 text-base rounded-full shadow-lg">
                Descarga el ebook gratuito <ArrowDown className="ml-2 w-4 h-4" />
              </Button>
              <Button variant="outline" className="border-[#c9a227] text-[#c9a227] px-8 py-6 text-base rounded-full">
                Ver formaciones <ArrowRight className="ml-2 w-4 h-4" />
              </Button>
            </div>
          </section>
        </div>
      </div>

      {/* OPCIÓN 2: Anillos concéntricos dorados (como el logo) */}
      <div className="py-12 px-4 bg-white">
        <h2 className="text-xl font-bold text-center mb-8 text-[#c9a227]">
          OPCIÓN 2: Anillos concéntricos (referencia al logo)
        </h2>
        
        <div className="max-w-5xl mx-auto">
          <section className="relative min-h-[550px] flex items-center justify-center py-16 overflow-hidden">
            {/* Background rings */}
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-[600px] h-[600px] rounded-full border border-[#c9a227]/10 absolute" />
              <div className="w-[450px] h-[450px] rounded-full border border-[#c9a227]/15 absolute" />
              <div className="w-[300px] h-[300px] rounded-full border border-[#c9a227]/20 absolute" />
              <div className="w-[150px] h-[150px] rounded-full bg-gradient-to-br from-[#c9a227]/20 to-transparent absolute" />
            </div>
            
            {/* Content */}
            <div className="relative text-center max-w-3xl px-6">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/80 text-[#c9a227] rounded-full text-sm font-medium mb-8 shadow-sm">
                <Sparkles className="w-4 h-4" />
                Escuela de Consciencia Akáshica
              </div>
              
              <h1 className="text-5xl lg:text-7xl font-serif text-gray-800 tracking-tight mb-6 leading-[1.1]">
                Un espacio para
                <span className="block text-[#c9a227]">volver a ti</span>
              </h1>
              
              <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-10 leading-relaxed font-light">
                Sin prisa. Sin ruido. De la desconexión a habitar tu vida con claridad.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button className="bg-[#c9a227] hover:bg-[#b89220] text-white px-8 py-6 text-base rounded-full shadow-lg">
                  Descarga el ebook gratuito <ArrowDown className="ml-2 w-4 h-4" />
                </Button>
                <Button variant="outline" className="border-[#c9a227] text-[#c9a227] bg-white/50 px-8 py-6 text-base rounded-full">
                  Ver formaciones <ArrowRight className="ml-2 w-4 h-4" />
                </Button>
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* OPCIÓN 3: Línea dorada decorativa (como Límites) */}
      <div className="py-12 px-4 bg-[#faf8f5]">
        <h2 className="text-xl font-bold text-center mb-8 text-[#c9a227]">
          OPCIÓN 3: Estilo Límites (minimalista con línea decorativa)
        </h2>
        
        <div className="max-w-5xl mx-auto">
          <section className="min-h-[550px] flex flex-col items-center justify-center py-16 text-center">
            {/* Decorative line */}
            <div className="w-24 h-[2px] bg-gradient-to-r from-transparent via-[#c9a227] to-transparent mb-12" />
            
            {/* Badge */}
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#c9a227]/10 text-[#c9a227] rounded-full text-sm font-medium mb-8">
              <Sparkles className="w-4 h-4" />
              Escuela de Consciencia Akáshica
            </div>
            
            {/* Title - larger, more dramatic */}
            <h1 className="text-6xl lg:text-8xl font-serif text-gray-800 tracking-tight mb-4 leading-[1]">
              volver a ti
            </h1>
            
            {/* Tagline */}
            <p className="text-2xl text-[#c9a227] font-light mb-8">
              Un espacio sin prisa. Sin ruido.
            </p>
            
            {/* Subtitle */}
            <p className="text-lg text-gray-500 max-w-xl mx-auto mb-12 leading-relaxed">
              De la desconexión y el esfuerzo constante, a habitar tu cuerpo y tu vida con claridad.
            </p>
            
            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button className="bg-[#c9a227] hover:bg-[#b89220] text-white px-8 py-6 text-base rounded-full shadow-lg">
                Descarga el ebook gratuito <ArrowDown className="ml-2 w-4 h-4" />
              </Button>
              <Button variant="outline" className="border-[#c9a227] text-[#c9a227] px-8 py-6 text-base rounded-full">
                Ver formaciones <ArrowRight className="ml-2 w-4 h-4" />
              </Button>
            </div>
            
            {/* Scroll indicator */}
            <div className="mt-16 animate-bounce">
              <ArrowDown className="w-5 h-5 mx-auto text-gray-400" />
            </div>
          </section>
        </div>
      </div>

      {/* OPCIÓN 4: Imagen real sutil de fondo (luz/naturaleza) */}
      <div className="py-12 px-4 bg-white">
        <h2 className="text-xl font-bold text-center mb-8 text-[#c9a227]">
          OPCIÓN 4: Con imagen de luz/naturaleza muy sutil de fondo
        </h2>
        
        <div className="max-w-6xl mx-auto">
          <section className="relative min-h-[550px] rounded-2xl overflow-hidden shadow-xl">
            {/* Background image - light rays */}
            <div className="absolute inset-0">
              <img 
                src="https://images.unsplash.com/photo-1507400492013-162706c8c05e?w=1200&q=80"
                alt="Light"
                className="w-full h-full object-cover opacity-30"
              />
              <div className="absolute inset-0 bg-gradient-to-b from-[#faf8f5]/90 via-[#faf8f5]/80 to-[#faf8f5]" />
            </div>
            
            {/* Content */}
            <div className="relative min-h-[550px] flex flex-col items-center justify-center py-16 text-center px-6">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#c9a227]/10 text-[#c9a227] rounded-full text-sm font-medium mb-8">
                <Sparkles className="w-4 h-4" />
                Escuela de Consciencia Akáshica
              </div>
              
              <h1 className="text-5xl lg:text-7xl font-serif text-gray-800 tracking-tight mb-6 leading-[1.1]">
                Un espacio para
                <span className="block text-[#c9a227]">volver a ti</span>
              </h1>
              
              <p className="text-xl text-gray-600 max-w-2xl mx-auto mb-10 leading-relaxed font-light">
                Sin prisa. Sin ruido. De la desconexión a habitar tu vida con claridad.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button className="bg-[#c9a227] hover:bg-[#b89220] text-white px-8 py-6 text-base rounded-full shadow-lg">
                  Descarga el ebook gratuito <ArrowDown className="ml-2 w-4 h-4" />
                </Button>
                <Button variant="outline" className="border-[#c9a227] text-[#c9a227] bg-white/50 px-8 py-6 text-base rounded-full">
                  Ver formaciones <ArrowRight className="ml-2 w-4 h-4" />
                </Button>
              </div>
            </div>
          </section>
        </div>
      </div>

      {/* Instructions */}
      <div className="py-8 bg-gray-900 text-white text-center">
        <h2 className="text-xl font-bold mb-4">¿Cuál te gusta más?</h2>
        <ul className="space-y-2 text-gray-300 max-w-lg mx-auto text-left px-6">
          <li>• <strong>Opción 1:</strong> Esfera dorada arriba del texto</li>
          <li>• <strong>Opción 2:</strong> Anillos concéntricos (como el logo)</li>
          <li>• <strong>Opción 3:</strong> Estilo Límites ultra-minimalista</li>
          <li>• <strong>Opción 4:</strong> Imagen de luz sutil de fondo</li>
        </ul>
      </div>
    </div>
  );
};

export default HeroImageTest;
